import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import image from '../assets/images/BashaaratLogo.svg';
import leftimage from '../assets/images/login-left-img.png';

import usericon from '../assets/images/register_icon/user_gray.svg';
import usericonGreen from '../assets/images/register_icon/user_brown.svg';

import defaultemail from '../assets/images/register_icon/mail_gray.svg';
import emailimage from '../assets/images/register_icon/mail_brown.svg';
import passimage from '../assets/images/register_icon/call_brown.svg';
import defaultpass from '../assets/images/register_icon/call_gray.svg';

import gstinIcon from '../assets/images/register_icon/gstin_gray.svg';
import gstinBrown from '../assets/images/register_icon/gstin_brown.svg';

import '../styles/AdminLogin.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';

const AdminRegister = ({ onLogin }) => {
  const [vendorName, setVendorName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [gstin, setGstin] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [focusField, setFocusField] = useState('');


  const navigate = useNavigate();



  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    // Validate Vendor Name
    if (!vendorName.trim()) {
      validationErrors.vendorName = 'Vendor Name cannot be empty';
    }

    // Validate Email
    if (!email.trim()) {
      validationErrors.email = 'Email cannot be empty';
    } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        validationErrors.email = 'Please enter a valid email address';
      }
    }

    // Validate Mobile: exactly 10 digits
    if (!mobile.trim()) {
      validationErrors.mobile = 'Mobile number cannot be empty';
    } else if (!/^[0-9]{10}$/.test(mobile)) {
      validationErrors.mobile = 'Mobile number must be exactly 10 digits';
    }

    // Validate GSTIN
    if (!gstin.trim()) {
      validationErrors.gstin = 'GSTIN cannot be empty';
    }

    // If there are any errors, update state and exit early.
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Clear any previous errors
    setErrors({});
    setErrorMessage('');

    try {
      const response = await api.post('vendor/add', {
        name: vendorName,
        email_id: email,
        mobile_no: mobile,
        gstin: gstin,
      });


      if (response.data && (response.data.status === 'success' || response.data.success === true)) {
        toast.success('Registration Successful');

        localStorage.setItem('vendorId', response.data.data.id);
        localStorage.setItem('vendor', JSON.stringify(response.data.data));
        onLogin(response.data.data);

        navigate('/dashboard'); // Navigate to dashboard after successful registration
      } else {
        toast.error(response.data.message || 'Failed to create vendor');
      }
    } catch (error) {
      console.error('Full error:', error.response || error);
      setErrorMessage(
        error.response?.data?.message || 'Error creating vendor. Please try again later.'
      );
    }
  };

  const getBorderColor = (field) =>
    focusField === field ? '1px solid #BC6C25' : '1px solid #E4C8AF';

  const getIcon = (field, focusedImg, defaultImg) =>
    focusField === field ? focusedImg : defaultImg;

  return (
    <div>
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-md-2 col-lg-12">
              <div className="form-container-login">
                <div className="row">
                  <div className="col-lg-6 p-0">
                    <img
                      className="img-fluid hideinmob"
                      src={leftimage}
                      alt="background"
                      style={{ height: '100vh', width: '100%' }}
                    />
                  </div>
                  <div className="col-lg-6 form-center">
                    <div className="login-logo text-center">
                      <img className="logoimg imginmob" src={image} alt="logo" />
                    </div>
                    <div className="login-border">
                      <form className="login-form" onSubmit={handleSubmit}>
                        {/* Vendor Name */}
                        <div className="input-container" style={{ borderBottom: getBorderColor('vendorName') }}>
                          <img
                            className="img-fluid"
                            src={getIcon('vendorName', usericonGreen, usericon)}
                            alt=""
                          />
                          <input
                            type="text"
                            placeholder="Vendor Name"
                            onFocus={() => setFocusField('vendorName')}
                            onBlur={() => setFocusField('')}
                            onChange={(e) => setVendorName(e.target.value)}
                            required
                          />
                        </div>
                        {errors.vendorName && <div className="text-danger">{errors.vendorName}</div>}

                        {/* Email */}
                        <div className="input-container" style={{ borderBottom: getBorderColor('email') }}>
                          <img
                            className="img-fluid"
                            src={getIcon('email', emailimage, defaultemail)}
                            alt=""
                          />
                          <input
                            type="email"
                            placeholder="Email"
                            onFocus={() => setFocusField('email')}
                            onBlur={() => setFocusField('')}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>
                        {errors.email && <div className="text-danger">{errors.email}</div>}

                        {/* Mobile Number */}
                        <div className="input-container" style={{ borderBottom: getBorderColor('mobile') }}>
                          <img
                            className="img-fluid"
                            src={getIcon('mobile', passimage, defaultpass)}
                            alt=""
                          />
                          <input
                            type="text"
                            placeholder="Mobile No."
                            onFocus={() => setFocusField('mobile')}
                            onBlur={() => setFocusField('')}
                            onChange={(e) => setMobile(e.target.value)}
                            required
                          />
                        </div>
                        {errors.mobile && <div className="text-danger">{errors.mobile}</div>}

                        {/* GSTIN */}
                        <div className="input-container" style={{ borderBottom: getBorderColor('gstin') }}>
                          <img
                            className="img-fluid"
                            src={getIcon('gstin', gstinBrown, gstinIcon)}
                            alt=""
                          />
                          <input
                            type="text"
                            placeholder="GSTIN No."
                            onFocus={() => setFocusField('gstin')}
                            onBlur={() => setFocusField('')}
                            onChange={(e) => setGstin(e.target.value)}
                            required
                          />
                        </div>
                        {errors.gstin && <div className="text-danger">{errors.gstin}</div>}

                        

                        <button type="submit" className="login-btn r-btn">
                          Register
                        </button>

                        <p style={{ marginTop: '15px', fontWeight: 700 }}>
                          Already a Vendor?{' '}
                          <Link to={'/'} style={{ textDecoration: 'none', color: '#105b3d' }}>
                            Login
                          </Link>
                        </p>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminRegister;
